import {useEffect, useState} from 'react';

import {useIntl} from 'react-intl';
import styled from 'styled-components';

import {FeaturesGroup} from '@stryd/models';
import {MembershipFeatureGroupList, colors} from '@stryd/react-ui';

import {useApi} from 'src/contexts/ApiContext';
import {usePageRegionData} from 'src/contexts/PageRegionDataContext';
import {IMembershipFeaturesTableFields} from 'src/utils/contentful';

import {FullWidthSection} from '../../FullWidthSection';
import {ContentfulTemplateComponentProps} from '../types';

const MembershipFeaturesTableWrapper = styled(FullWidthSection)`
  background-color: ${colors.themes.dark.backgroundLayers[0]};
  flex-direction: column;
`;

const MembershipFeaturesTableTitle = styled.h2`
  color: ${colors.themes.dark.headerText};
  margin-bottom: 50px;
`;

const ErrorMessage = styled.span`
  color: ${colors.themes.dark.text};
`;

type MembershipFeaturesTableProps =
  ContentfulTemplateComponentProps<IMembershipFeaturesTableFields>;

const tableStyle: React.CSSProperties = {
  marginBottom: '30px',
};

export const MembershipFeaturesTable: React.FC<
  React.PropsWithChildren<MembershipFeaturesTableProps>
> = (props) => {
  const {entry} = props;

  const intl = useIntl();
  const {locale} = usePageRegionData();
  const api = useApi();

  const [featureGroups, setFeatureGroups] = useState<FeaturesGroup[] | null>(
    null
  );

  useEffect(() => {
    const getFeatureGroups = async (): Promise<void> => {
      const res = await api.feature.getFeatures({locale});
      if (res.ok) {
        setFeatureGroups(res.data);
      } else {
        console.log('failed to get data for membership features table');
      }
    };

    getFeatureGroups();
  }, [api.feature, locale]);

  const {tableTitle} = entry.fields;

  return (
    <MembershipFeaturesTableWrapper id={'membership-features-table'}>
      <MembershipFeaturesTableTitle>{tableTitle}</MembershipFeaturesTableTitle>
      {featureGroups ? (
        <MembershipFeatureGroupList
          // @ts-ignore
          featureGroups={featureGroups}
          tableStyle={tableStyle}
          dataOnlyHeaderText={intl.formatMessage({
            id: 'data.featureAccess.title',
            defaultMessage: 'Data Only',
          })}
          membershipHeaderText={intl.formatMessage({
            id: 'full.featureAccess.title',
            defaultMessage: 'Membership',
          })}
        />
      ) : (
        <ErrorMessage>
          Sorry, there was a problem getting the list of features. Please
          refresh the page or try again later.
        </ErrorMessage>
      )}
    </MembershipFeaturesTableWrapper>
  );
};
